export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const ADD_CREDITS = "ADD_CREDITS";
export const USE_CREDITS = "USE_CREDITS";
export const UPDATE_USER = "UPDATE_USER";
